import { CmsObjectWithDefault } from '@components/Cms/types';

export type TimedLinkCmsKey = 'secondsRemaining';

export const TimedLinkCmsWithDefault: CmsObjectWithDefault<TimedLinkCmsKey> = {
    secondsRemaining: {
        cmsId: 97932,
        defaultTranslation: '({0} seconds)',
    },
};
